import React from 'react';

const Products = () => (
    <p> Products Page </p>
)

export default Products;
